import React from "react";
import PropTypes from 'prop-types';

const autoCloseSecondsDelay = 10;

export default class Banner extends React.PureComponent {
    state = {
        isOpen: true,
    };
    static getDerivedStateFromProps(props, state) {
        if (typeof props.isOpen !== 'undefined' && props.isOpen !== state.isOpen) {
            return {...state, isOpen: props.isOpen};
        }

        return null;
    }
    componentDidMount() {
        let { isNoAutoClose, onCloseCallback } = this.props;

        this.setState({
            isOpen: true,
        });

        if (!isNoAutoClose) {
            setTimeout(() => {
                this.setState({
                    isOpen: false,
                });

                onCloseCallback();
            }, autoCloseSecondsDelay * 1000);
        }
    }

    render() {
        let { children, button, className, isWithImage } = this.props;
        let { isOpen } = this.state;

        let styles = isOpen ? {top: 0} : {};

        const content = <><div className={'text'}>{children}</div><div className={'banner-button'}>{button}</div></>;
        return (
            <div className={`banner${className ? ` ${className}` : ''}${isWithImage ? ' with-image' : ''}`} style={styles}>
                <div className={'banner-content'}>
                    {isWithImage ? <div className={'left'}>
                        {content}
                    </div> : content}
                </div>
            </div>
        );
    }
}
// {isWithImage ? <div className={'right'}><img alt={'Banner image'} src={require('../../assets/images/banner-image.svg')}/></div> : false}
Banner.propTypes = {
    isOpen: PropTypes.bool,
    isWithImage: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    button: PropTypes.node.isRequired,
    isNoAutoClose: PropTypes.bool,
    onCloseCallback: PropTypes.func,
};
